import React from 'react'
import './FooterNavitem.css'
import { Link } from 'react-router-dom'
export default function FooterNavitem(props) {
    return (
        <Link to={props.route}>
            <a className='footer-navitem fs-medium clr-primary-heading fw-regular'>
                {props.itemName}
            </a>
        </Link>

    )
}
